import { Component, HostListener, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChartData, MultiLineChartComponent } from '../../../../_shared';
import { DateFilterComponent } from '../../../../../_shared/components';
import { DateInterval } from '../../../../../_shared/enums';
import { DateIntervalFilterData } from '../../../../../_shared/models';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-fuel-consumption-full-modal',
  standalone: true,
  imports: [MultiLineChartComponent, DateFilterComponent, TranslocoDirective], // , FulllineChartFuel
  templateUrl: './fuel-consumption-full-modal.component.html',
  styleUrl: './fuel-consumption-full-modal.component.scss'
})
export class FuelConsumptionFullModal {
  // Mock headline figures until the API supplies this summary.
  protected readonly headline = { value: '40ℓ/km', change: '+3.12%' };
  private readonly modalRef = inject(NgbActiveModal);

  protected lineChartData: any[] = ChartData.fuelConsumption;
  protected chartConfig: any[] = ChartData.fuelConsumptionLineConfig;

  protected buttonMenuClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  public utilizationDateFilter: DateIntervalFilterData;
  public defaultInterval: DateInterval = DateInterval.Day;

  constructor() {
    this.utilizationDateFilter = {} as DateIntervalFilterData;
  }

  onUtilizationDateFilterChange(filter: DateIntervalFilterData): void {
    this.utilizationDateFilter = filter;
  }

  closeModal(): void {
    this.modalRef.close();
  }
}
